import { render, staticRenderFns } from "./cargoDepartmentSelect.vue?vue&type=template&id=3c08c4e9&"
import script from "./cargoDepartmentSelect.vue?vue&type=script&lang=js&"
export * from "./cargoDepartmentSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c08c4e9')) {
      api.createRecord('3c08c4e9', component.options)
    } else {
      api.reload('3c08c4e9', component.options)
    }
    module.hot.accept("./cargoDepartmentSelect.vue?vue&type=template&id=3c08c4e9&", function () {
      api.rerender('3c08c4e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/cargoDepartmentSelect.vue"
export default component.exports